import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import MenuItem from '@mui/material/MenuItem';
import {
    medthodsOfDispatch,
    typesOfShipment
} from '../../../../../../utils/appconstants';
import PortsAutocomplete from '../../../../../autocompletewithapi/PortsAutocomplete';
import Customdatepicker from '../../../../../customdatepicker/customdatepicker';
import CustomTextField from '../../../../../CustomTextInput';
import NewCustomSelect from '../../../../../newcustomselect/newcustomselect';
import { SuitUIButton } from '../../../../../SuitUIButton';
import UploadLogo from '../../../common/UploadLogo';
import UploadStamp from '../../../common/UploadStamp';
import { CorporatePartner } from '../../../../../../interfaces/CorporatePartner';
import {
    Proforma,
    ProformaFormErrors
} from '../../../../../../interfaces/Proforma';
import { TransformedItems } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import Quotefield from '../../../../../../pages/dashboard/tradedocuments/quotation/quotefield/quotefield';

interface ProformaStepOneFormProps {
    updateField: (name: string, value: string | number) => void;
    payload: Proforma;
    corporatePartners: CorporatePartner[];
    loadingCorporatepartners: boolean;
    setShowAddPartner: Dispatch<SetStateAction<boolean>>;
    errors: ProformaFormErrors;
    quoteFields: TransformedItems[];
    updateQuoteField: (
        index: number,
        attributeName: keyof TransformedItems,
        attributeValue: TransformedItems[keyof TransformedItems]
    ) => void;
    removeQuoteField: (index: number) => void;
    addQuoteField: () => void;
}

const StepOne = ({
    updateField,
    payload,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    addQuoteField
}: ProformaStepOneFormProps) => {
    return (
        <div className='w-full flex flex-col gap-4'>
            <UploadLogo {...{ payload, updateField }} />

            <UploadStamp {...{ payload, updateField }} />

            <NewCustomSelect
                selectValue={payload.sellerId as unknown as string}
                required
                selectOptions={
                    corporatePartners as unknown as (
                        | string
                        | Record<string, unknown>
                    )[]
                }
                name={'sellerId'}
                updateField={(_, value) => {
                    updateField('sellerId', value);
                    updateField(
                        'sellerAddress',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.address
                    );
                    updateField(
                        'sellerName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.name
                    );
                    updateField(
                        'sellerBankName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.bankName
                    );
                    updateField(
                        'sellerAccountNumber',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.bankAccountNumber
                    );
                    updateField(
                        'sellerSwiftCode',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.swiftCode
                    );
                    updateField(
                        'bankDetails',
                        `Bank Name: ${corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]
                            ?.bankName}\r\nAccount Number: ${corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]
                            ?.bankAccountNumber}\r\nSwift Code: ${corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.swiftCode}`
                    );
                }}
                label={'Invoice From'}
                // alternativeValue='shippingLineId'
                selectOptionLabel='name'
                loading={loadingCorporatepartners}
                dropdownRender={() => {
                    return (
                        <div className='px-4 border-t border-appcolorgreyfaint'>
                            <p
                                className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                onClick={() => {
                                    setShowAddPartner(true);
                                }}
                            >
                                + Add a New Partner
                            </p>
                        </div>
                    );
                }}
            />

            <CustomTextField
                error={!!errors?.invoiceNumber}
                helperText={errors?.invoiceNumber}
                required
                id='proformainvoice-invoiceNumber'
                label='Invoice Number'
                name='invoiceNumber'
                value={payload?.invoiceNumber}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('invoiceNumber', e.target.value);
                }}
            />

            <Customdatepicker
                value={payload?.invoiceDate || null}
                id='Proforma-invoiceDate'
                label='Invoice Date'
                name='invoiceDate'
                updateField={updateField}
                error={!!errors?.invoiceDate}
                helperText={errors?.invoiceDate}
            />

            <NewCustomSelect
                selectValue={payload.receiverId as unknown as string}
                required
                selectOptions={
                    corporatePartners as unknown as (
                        | string
                        | Record<string, unknown>
                    )[]
                }
                name={'receiverId'}
                updateField={(_, value) => {
                    updateField('receiverId', value);
                    updateField(
                        'receiverAddress',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.address
                    );
                    updateField(
                        'receiverName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.name
                    );
                }}
                label={'Invoice  To'}
                // alternativeValue='shippingLineId'
                selectOptionLabel='name'
                loading={loadingCorporatepartners}
                dropdownRender={() => {
                    return (
                        <div className='px-4 border-t border-appcolorgreyfaint'>
                            <p
                                className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                onClick={() => {
                                    setShowAddPartner(true);
                                }}
                            >
                                + Add a New Partner
                            </p>
                        </div>
                    );
                }}
            />

            <CustomTextField
                error={errors?.buyerReference.length > 0}
                helperText={
                    errors?.buyerReference.length > 0
                        ? errors?.buyerReference
                        : undefined
                }
                required
                id='proformainvoice-buyerReference'
                label='Buyer Reference'
                name='buyerReference'
                value={payload?.buyerReference}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('buyerReference', e.target.value);
                }}
            />

            <PortsAutocomplete
                errorCondition={!!errors?.portOfLoadingId}
                helperText={errors?.portOfLoadingId}
                id='Proforma-portOfLoading'
                label='Port of Loading'
                name='portOfLoadingId'
                updateField={updateField}
                nameValue='portOfLoadingValue'
                value={payload.portOfLoadingValue}
            />

            <PortsAutocomplete
                errorCondition={!!errors?.portOfDischargeId}
                helperText={errors?.portOfDischargeId}
                id='Proforma-portOfDischargeId'
                label='Port of Discharge'
                name='portOfDischargeId'
                updateField={updateField}
                nameValue='portOfDischargeValue'
                value={payload.portOfDischargeValue}
            />

            <CustomTextField
                select
                error={!!errors?.methodOfDispatch}
                helperText={errors?.methodOfDispatch}
                required
                id='proformainvoice-methodOfDispatch'
                label='Method of Dispatch'
                name='methodOfDispatch'
                value={payload?.methodOfDispatch}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('methodOfDispatch', e.target.value);
                }}
            >
                {medthodsOfDispatch.map((item, index) => (
                    <MenuItem
                        value={item}
                        key={`medthodsOfDispatch-${item}-${index}`}
                    >
                        {item}
                    </MenuItem>
                ))}
            </CustomTextField>

            <CustomTextField
                select
                error={!!errors?.typeOfShipment}
                helperText={errors?.typeOfShipment}
                required
                id='proformainvoice-typeOfShipment'
                label='Type of Shipment'
                name='typeOfShipment'
                value={payload?.typeOfShipment}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('typeOfShipment', e.target.value);
                }}
            >
                {typesOfShipment.map((item, index) => (
                    <MenuItem
                        value={item}
                        key={`typesOfShipment-${item}-${index}`}
                    >
                        {item}
                    </MenuItem>
                ))}
            </CustomTextField>
            <div className='border border-gray300 border-dashed mt-4' />
            <CustomTextField
                error={!!errors?.salesContractNumber}
                helperText={errors?.salesContractNumber}
                value={payload?.salesContractNumber}
                required
                id='proformainvoice-salesContractNumber'
                label='Sales Contract Number'
                name='salesContractNumber'
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('salesContractNumber', e.target.value);
                }}
            />

            {quoteFields.map((item, index) => (
                <Quotefield
                    item={item}
                    key={item.id}
                    index={index}
                    id={item.id ?? ''}
                    updateQuoteField={updateQuoteField}
                    price={item.price ?? 0}
                    qty={item.qty ?? 0}
                    removeQuoteField={removeQuoteField}
                />
            ))}

            <SuitUIButton
                text='Add field'
                onClick={addQuoteField}
                invert
                fullWidth
                style='px-[0.92rem] border border-gray300 text-steelBlue font-medium text-sm leading-[20px] lg:border-none lg:text-appcolorprimary'
            />
        </div>
    );
};

export default StepOne;
